export default "__VITE_ASSET__Di87WAw4__"